import { supabase } from '../lib/supabase';

export const contactService = {
  // Submit a contact form message
  async submitMessage(messageData) {
    try {
      // Debug: Check current auth state
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      console.log('Current user:', user);
      console.log('Auth error:', authError);
      
      // Debug: Check session
      const { data: { session } } = await supabase.auth.getSession();
      console.log('Current session:', session);

      const { data, error } = await supabase
        .from('customer_messages')
        .insert([{
          name: messageData.name,
          email: messageData.email,
          subject: messageData.subject,
          message: messageData.message,
          user_id: messageData.user_id || null,
          ip_address: messageData.ip_address || null,
          user_agent: messageData.user_agent || null
        }]);

      if (error) {
        console.error('Error submitting contact message:', error);
        console.error('Full error details:', JSON.stringify(error, null, 2));
        throw error;
      }

      return { success: true, data };
    } catch (error) {
      console.error('Contact service error:', error);
      return { success: false, error: error.message };
    }
  },

  // Get user's contact messages (if they have a user_id)
  async getUserMessages(userId) {
    try {
      const { data, error } = await supabase
        .from('customer_messages')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching user messages:', error);
        throw error;
      }

      return { success: true, data };
    } catch (error) {
      console.error('Contact service error:', error);
      return { success: false, error: error.message };
    }
  }
};
